/*!
 * ContextMenu - jQuery plugin for right-click context menus
 *
 * Author: Chris Domigan
 * Contributors: Dan G. Switzer, II
 * Parts of this plugin are inspired by Joern Zaefferer's Tooltip plugin
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
 * Version: r2
 * Date: 16 July 2007
 *
 * For documentation visit http://www.trendskitchens.co.nz/jquery/contextmenu/
 *
 * RF 02/2024
 * - add option templateElementId and fn .updateContextMenu() and tracking of lastBoundToElement
 * RF 11/2008:
 * - added onHideMenu option (in practice it hides the "input blocking" layer which was shown at onShowMenu)
 * - added keypressed event to hide menu
 * RF 02/2010:
 * - keep menu on-screen (adjust position if menu reaches below bottom or right document border)
 * RF 03/2011:
 * - added separator entries
 * - removed inline css
 * MH
 * - moved separator entries to ignore
 */

( function( factory ) {
	if( typeof define === 'function' && define.amd ) {
		define( ['jquery'], function( jQuery ) {
			return factory( jQuery, window );
		} );
	} else if( typeof exports === 'object' && module.exports ) {
		module.exports = factory( require( 'jquery' ), window );
	} else {
		factory( jQuery, window );
	}
}( function( $, window, undefined ) {
	"use strict";

	var content;
	var hash = {};
	var defaults = {
		eventPosX: 'pageX',
		eventPosY: 'pageY',
		shadow: true,
		onContextMenu: null,
		onShowMenu: null,
		onHideMenu: null,
		onUpdateMenu: null,
		appendTo: null,
		templateElementId: null,
		requireForwardedContextmenuEvent: false,
	};
	$.fn.updateContextMenu = function( id, evt ) {
		const cur = hash[id] ?? null;
		if( cur!==null && cur.lastBoundToElement ) {
			hide(cur,'updateContextMenu');
			display(id,evt,'updateContextMenu');
		}
	};

	$.fn.contextMenu = function( id, options ) {
		// console.log({w:'$.fn.contextMenu',id,options});

		if( hash[id] !== undefined ) {
			hash[id].menu.remove();
			if( hash[id].shadow ) hash[id].shadowElem.remove();
			hash[id].lastBoundToElement = null;
		}
		const templateElementId = options.templateElementId ?? id;
		const templateIdPfx = options.templateIdPfx ?? ( templateElementId+'-');	// 'tmpl-';
		const cssClassName = options.cssClassName ?? 'media-ctx-menu';
		const requireForwardedContextmenuEvent = options.requireForwardedContextmenuEvent ?? false;

		var cur = {
			id: id,
			templateElementId,
			templateIdPfx,
			cssClassName,
			requireForwardedContextmenuEvent,
			bindings: options.bindings || {},
			dynamic: options.dynamic || {},
			shadow: options.shadow || options.shadow === false ? options.shadow : defaults.shadow,
			onContextMenu: options.onContextMenu || defaults.onContextMenu,
			onShowMenu: options.onShowMenu || defaults.onShowMenu,
			onHideMenu: options.onHideMenu || defaults.onHideMenu,
			onUpdateMenu: options.onUpdateMenu || defaults.onUpdateMenu,
			eventPosX: options.eventPosX || defaults.eventPosX,
			eventPosY: options.eventPosY || defaults.eventPosY,
			trigger: null,
			menu: null,
			shadowElem: null,
			appendTo: options.appendTo || defaults.appendTo || 'body',
			lastBoundToElement: this,
			original_event: null,
		};
		if( typeof cur.appendTo === 'string' ) cur.appendTo = $( cur.appendTo );

		if( cur.id !== cur.templateElementId ) {
			const $templateElement = $('#'+cur.templateElementId);
			const processedClassName = 'ctx-menu-pfxs-processed-'+cur.id;
			if( !$templateElement.hasClass(processedClassName) ) {
				$templateElement.find('ul:first').find('li').each( function( idx, elem ) {
					let $elem = $(elem);
					const id = $elem.prop('id');
					if( id && !id.startsWith(cur.templateIdPfx) ) {
						$elem.prop('id',cur.templateIdPfx+id)
					}
				} );
				$templateElement.addClass(processedClassName);
			}
		}

		cur.menu = $( '<div id="'+id+'" class="'+cssClassName+'"></div>' )
			.hide()
			.css( { position: 'absolute', zIndex: 1500 } )
			.appendTo( cur.appendTo )
			.on( 'click.jqContextMenu', function( e ) {
				// console.log({w:'click.jqContextMenu',e});
				e.stopPropagation();
			} );

		if( cur.shadow ) {
			cur.shadowElem = $( '<div class="contextmenu-background-custom"></div>' )
				.css( { position: 'absolute', opacity: 0.2, zIndex: 1499 } )
				.appendTo( cur.appendTo )
				.hide();
		}
		hash[id] = cur;

		//var index = hash.length - 1;
		var index = id;
		$(this).off('contextmenu.jqContextMenu').on( 'contextmenu.jqContextMenu', function( e ) {
			var cur = hash[index];

			const isForwardedEvent = e.isForwardedEvent ?? false;
			// const triggeredBy = e.triggeredBy ?? '';
			// const triggeredByEvtType = e.triggeredByEvtType ?? '';
			// const triggeredByEvtWhich = e.triggeredByEvtWhich ?? 1;
			// console.log({w:'contextmenu.jqContextMenu',index, id, cur_id:cur.id, cur, e, eType:e.type, curRequireForwardedContextmenuEvent: cur.requireForwardedContextmenuEvent, isForwardedEvent });

			cur.original_event = e;

			var bShowContext = true;
			if( !!cur.onContextMenu ) {
				bShowContext = cur.onContextMenu( e, cur.menu );
			}

			if( e.type==='contextmenu' && !isForwardedEvent ) {
				let curRequireForwardedContextmenuEvent = false;
				if( typeof cur.requireForwardedContextmenuEvent === 'function' ) {
					curRequireForwardedContextmenuEvent = cur.requireForwardedContextmenuEvent( e, cur.menu );
				} else {
					curRequireForwardedContextmenuEvent = !!cur.requireForwardedContextmenuEvent;
				}
				if( curRequireForwardedContextmenuEvent ) {
					return true; // let other handler handle this...
				}
			}

			cur.trigger = this;
			if( bShowContext ) {
				display( index, e, 'contextmenu.jqContextMenu' );
			}

			e.preventDefault();
			e.stopPropagation();
			return false;
		} );

		return {
			cur: hash[id],
			updateContent: function(dyn_content) {
				// console.log({w:'updateContent'});
				cur.dynamic = dyn_content;
				if( cur.original_event ) {
					buildmenu(cur, cur.original_event, 'updateContent');
					placemenu(cur, cur.original_event);
				} else {
					// console.log({ w:'updateContent FAILED: cur.original_event is not set !' });

				}
			}
		};
	};

	function buildmenu( cur, evt, calledFrom ) {
		// console.log({w:'buildmenu',calledFrom});

		$('.dynamic', cur.menu).remove();
		let after_entry = $('.additions', cur.menu);

		if(cur.dynamic.html) {
			for(let i = 0; i < cur.dynamic.html.length; i++) {
				let d = $(cur.dynamic.html[i]).addClass('dynamic');
				after_entry.after(d);
				after_entry = cur.dynamic.html[i];
			}
		}

		// if there's an onShowMenu, run it now -- must run after content has been added
		// if you try to alter the content variable before the menu.html(), IE6 has issues
		// updating the content
		if( !!cur.onShowMenu ) {
			cur.menu = cur.onShowMenu( evt, cur.menu, calledFrom+' -> buildmenu' );
		}

		$( 'li:not(.ignore)', cur.menu ).each(function(idx, elem) {
			const $elem = $(elem);
			let id = $elem.prop('id');
			$elem.attr('tabindex', idx+1);
			$elem.off('click.jqContextMenu');
			if( $elem.hasClass('submenu') ) {
				// keep submenu entries .. until next loop ...

			} else if( $elem.hasClass('infosubmenu') ) {
				// always keep infosubmenu entries as is

			} else if( id !== undefined && id !== '' ) {
				if( cur.bindings[id] !== undefined ) {
					$elem.on('click.jqContextMenu', function(evt) {

						// console.log({w:'cur.bindings[id] -> click.jqContextMenu',id,evt});

						hide(cur,'cur.bindings[id] -> click.jqContextMenu');
						cur.bindings[id](cur.trigger);
					});
				} else if( cur.dynamic.bindings && cur.dynamic.bindings[id] !== undefined ) {
					$elem.on('click.jqContextMenu', function(evt) {

						// console.log({w:'cur.dynamic.bindings[id] -> click.jqContextMenu',id,evt});

						hide(cur,'cur.dynamic.bindings[id] -> click.jqContextMenu');
						cur.dynamic.bindings[id](evt);
					});
				} else {
					$elem.remove();
				}
			}
		} );

		// remove empty submenu entries ..
		$( 'li.submenu:not(.ignore)', cur.menu ).each( function( idx, elem ) {
			const $elem = $(elem);
			const submenuItemsCount = $elem.find('>ul>*').length;
			if( submenuItemsCount===0 ) {
				$elem.remove();
			}
		} );
	}

	function placemenu( cur, evt ) {

		var page_w = cur.appendTo.width();
		var page_h = cur.appendTo.height();

		const eventPageX = evt[cur.eventPosX] ?? null;
		const eventPageY = evt[cur.eventPosY] ?? null;

		var mn_w = cur.prev_mn_w ?? 0;
		var mn_h = cur.prev_mn_h ?? 0;
		if( eventPageX!==null && eventPageY!==null ) {
			mn_w = cur.menu.width();
			mn_h = cur.menu.height();
		}
		cur.prev_mn_w = mn_w;
		cur.prev_mn_h = mn_h;

		var mn_x = cur.prev_mn_x ?? 0;
		var mn_y = cur.prev_mn_y ?? 0;
		if( eventPageX!==null && eventPageY!==null ) {
			mn_x = eventPageX + 2;
			mn_y = eventPageY + 2;
		}
		cur.prev_mn_x = mn_x;
		cur.prev_mn_y = mn_y;

		mn_x -= cur.appendTo.offset().left;
		mn_y -= cur.appendTo.offset().top;

		// fit into bounds of options.appendTo element
		var pad = 25;
		if( mn_x > page_w - pad - mn_w ) mn_x = page_w - pad - mn_w;
		if( mn_x < pad ) mn_x = pad;
		if( mn_y > page_h - pad - mn_h ) mn_y = page_h - pad - mn_h;
		if( mn_y < pad ) mn_y = pad;


		cur.menu.css( { 'left': mn_x, 'top': mn_y, display: 'block' } );
		if( cur.shadow ) cur.shadowElem.css( { width: mn_w, height: mn_h, left: mn_x + 4, top: mn_y + 4, display: 'block' } );

		var tb_action_nodes = $( 'li:not(.ignore)', cur.menu ),
			focus_node = $( '#media-ctxm-open,#media-ctxm-cat-open' );
		if( focus_node.length === 0 ) focus_node = tb_action_nodes.first();
		focus_node.focus();
		var tb_submenu_nodes = $( 'li.submenu', cur.menu);
		tb_submenu_nodes.each( function( idx ) {
			let elem = $(this);
			if(elem.find('> ul').length) {
				let child_list = elem.find('> ul');
				child_list.attr('style', 'display: block !important');	// we need to display it shortly to get offset
				let offset = child_list.offset();
				elem.removeClass('right').removeClass('left');
				if(child_list.width() + offset.left + pad > page_w) elem.addClass('left');
			}
		} );
		tb_submenu_nodes.each( function( idx ) {
			let elem = $(this);
			if(elem.find('> ul').length) {
				let child_list = elem.find('> ul');
				child_list.attr('style', '');
			}
		} );
		tb_submenu_nodes.each( function( idx ) {
			let elem = $(this);
			if(elem.find('> ul').length) {
				let child_list = elem.find('> ul');
				let offset = elem.offset();
				if(child_list.height() + offset.top + pad > page_h) {
					let shift = page_h - pad - offset.top - child_list.height();
					child_list.attr('style', 'top: '+shift+'px !important');
				}
			}
		} );
	}

	function display( index, e, calledFrom ) {
		// console.log({w:'display',calledFrom});

		var cur = hash[index];
		cur.original_event = e;


		const $templateElement = $('#'+cur.templateElementId);
		content = $templateElement.find('ul:first').clone(true);

		if( cur.id !== cur.templateElementId ) {
			const processedClassName = 'ctx-menu-pfxs-processed-'+cur.id;
			if( $templateElement.hasClass(processedClassName) ) {
				const templateIdPfx = cur.templateIdPfx ?? 'tmpl-';
				content.find('li').each( function( idx, elem ) {
					let $elem = $(elem);
					const id = $elem.prop('id');
					if( id && id.startsWith(templateIdPfx) ) {
						const newId = id.substr(templateIdPfx.length);
						$elem.prop('id',newId);
					}
				} );
			}
		}

		// hide possible open select2 boxes
		$('.select2-hidden-accessible').select2('close');


		// Send the content to the menu
		cur.menu.html( content );

		buildmenu(cur, e, calledFrom+' -> display' );
		placemenu(cur, e);

		$( document )
			.one( 'click.jqContextMenu', cur, hide )
			.one( 'dragstart', cur, hide)
			//.one( 'contextmenu.jqContextMenu', cur, hide )
			.one( 'keydown.jqContextMenu', cur, keydownhandler )
			.one( 'mousedown.jqContextMenu', cur, mousedownhandler );
	}

	function hide( e, calledFrom ) {
		var cur = e.data ? e.data : e;

		// console.log({w:'hide',calledFrom,e,cur});

		if( !!cur.onHideMenu ) cur.onHideMenu( cur.menu );
		cur.menu.hide();
		cur.shadowElem.hide();
		$( document ).off( '.jqContextMenu' );
	}

	function keydownhandler( e ) {
		var cur = e.data ? e.data : e;

		// console.log({w:'keydownhandler',e,cur});

		/*
		if( e.which == 27 ) hide(e);//$(document).click();
		//else if( e.which == 38 ) {} // todo: up-arrow
		//else if( e.which == 40 ) {} // todo: down-arrow
		else $(document).one( 'keydown.jqContextMenu', cur, keydownhandler );
		*/
		var tb_action_nodes = $( 'li:not(.ignore)', cur.menu ),
			focused_node = tb_action_nodes.filter( ':focus' ),
			focus_id = focused_node.prop( 'id' ),
			focus_idx = 0,
			tb_action_ids = [];
		tb_action_nodes.each( function( idx ) {
			var id = $( this ).prop( 'id' );
			tb_action_ids.push( id );
			if( id == focus_id ) focus_idx = idx;
		} );

		var bind_again = false;
		switch( e.which ) {
			case 9: // tab
				if( e.shiftKey ) var new_focus_idx = ( focus_idx - 1 + tb_action_ids.length ) % tb_action_ids.length;
				else var new_focus_idx = ( focus_idx + 1 ) % tb_action_ids.length;
				focused_node.removeClass('focussed').closest('ul').removeClass('focussed');
				tb_action_nodes.eq( new_focus_idx ).closest('ul').addClass('focussed');
				tb_action_nodes.eq( new_focus_idx ).addClass('focussed').focus();
				e.preventDefault();
				bind_again = true;
				break;
			case 37: // left
				var new_focus_idx = ( focus_idx - 1 + tb_action_ids.length ) % tb_action_ids.length;
				focused_node.removeClass('focussed').closest('ul').removeClass('focussed');
				tb_action_nodes.eq( new_focus_idx ).closest('ul').addClass('focussed');
				tb_action_nodes.eq( new_focus_idx ).addClass('focussed').focus();
				bind_again = true;
				break;
			case 39: // right
				var new_focus_idx = ( focus_idx + 1 ) % tb_action_ids.length;
				focused_node.removeClass('focussed').closest('ul').removeClass('focussed');
				tb_action_nodes.eq( new_focus_idx ).closest('ul').addClass('focussed');
				tb_action_nodes.eq( new_focus_idx ).addClass('focussed').focus();
				bind_again = true;
				break;
			case 38: // up
				var new_focus_idx = ( focus_idx - 1 + tb_action_ids.length ) % tb_action_ids.length;
				focused_node.removeClass('focussed').closest('ul').removeClass('focussed');
				tb_action_nodes.eq( new_focus_idx ).closest('ul').addClass('focussed');
				tb_action_nodes.eq( new_focus_idx ).addClass('focussed').focus();
				bind_again = true;
				break;
			case 40: // down
				var new_focus_idx = ( focus_idx + 1 ) % tb_action_ids.length;
				focused_node.removeClass('focussed').closest('ul').removeClass('focussed');
				tb_action_nodes.eq( new_focus_idx ).closest('ul').addClass('focussed');
				tb_action_nodes.eq( new_focus_idx ).addClass('focussed').focus();
				bind_again = true;
				break;
			case 13: // enter
			case 32: // space
				if( cur.bindings.hasOwnProperty( focus_id ) ) {
					var fn = cur.bindings[focus_id];
					hide(cur,'keydownhandler which='+e.which);
					fn( cur.trigger );
					e.preventDefault();
					return false;
				}
				bind_again = true;
				break;
			case 27: // escape
			case 77: // M
				hide(cur,'keydownhandler which='+e.which);
				e.preventDefault();
				return false;
		}

		if( bind_again ) {
			$( document ).one( 'keydown.jqContextMenu', cur, keydownhandler );
			return false;
		}
	}

	function mousedownhandler( e ) {
		var cur = e.data ? e.data : e;

		// console.log({w:'mousedownhandler',e,cur,eWhich:e.which});

		if( $( e.target ).closest( '#' + cur.id ).length === 0 ) {
			hide(cur,'mousedownhandler e.which='+e.which);
		} else {
			// $( document ).one( 'mousedown.jqContextMenu', cur, mousedownhandler );
			$( document ).one( 'mousedown.jqContextMenu', cur, function( evt ) {
				// console.log({w:'wrapped mousedownhandler',e,evt,cur,evtWhich:evt.which});
				return mousedownhandler(evt);
			} );
		}
	}

	// Apply defaults
	$.contextMenu = {
		defaults: function( userDefaults ) {
			$.each( userDefaults, function( i, val ) {
				if( typeof val == 'object' && defaults[i] ) {
					$.extend( defaults[i], val );
				} else {
					defaults[i] = val;
				}
			} );
		}
	};
} ) );

